import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const SidebarDateFilter = (props) => {
  const { label, placeholder, onChange } = props

  return (
    <Search>
      <label>{label}</label>
      <input type="date" placeholder={placeholder} onChange={onChange} />
    </Search>
  )
}

const Search = styled.div`
  padding: 0 20px;
  margin-bottom: 10px;
  label {
    color: #fff;
    font-size: 13px;
    text-transform: uppercase;
  }
  input {
    width: 100%;
    box-sizing: border-box;
    padding: 6px 10px;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    border: 1px solid #fff;
    border-radius: 4px;
    font-size: 15px;
    ::placeholder {
      color: rgba(255, 255, 255, 0.6);
      font-family: 'regular';
    }
  }
`

SidebarDateFilter.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
}

export default SidebarDateFilter
